import { TimeZone } from "./TimeZone";
import moment from "moment-timezone";
import { ZoneList } from "./ZoneList";

export const checkSlots = (date, slot) => {
  var bookingTime = new Date();
  // let bookingDate = date.split("-");
  var bookingTime = new Date(
    date.year + " " + date.month + " " + date.day + "," + slot
    );
  let currentTime = new Date();
  if (bookingTime.getTime() > currentTime.getTime()) {
    return true;
  }else{
    return false
  }
};

export const showSlots = (date, slots) => {
  let flag;
  let currentTime = new Date();
  Object.keys(slots).map((i) => {
    slots[i].map((j) => {
      var bookingTime = new Date(
        date.split("-")[0] +
          " " +
          date.split("-")[1] +
          " " +
          date.split("-")[2] +
          "," +
          j
      );
      if (bookingTime.getHours() < currentTime.getHours()) {
        flag = true;
      }else{
        flag = false;
      }
    });
  });
  return flag;
};


export function compareTimes(currentTime, compareTime) {
  const currentDateTime = new Date(); 
  const currentTimeParts = currentTime.split(' '); // Split time and AM/PM
  const [hours, minutes] = currentTimeParts[0].split(':'); // Split time into hours and minutes
  const ampm = currentTimeParts[1];

  // Adjust the hours based on AM/PM
  let hoursIn24Format = parseInt(hours);
  if (ampm === 'PM' && hoursIn24Format !== 12) {
    hoursIn24Format += 12;
  } else if (ampm === 'AM' && hoursIn24Format === 12) {
    hoursIn24Format = 0;
  }

  // Set the current time with adjusted hours and minutes
  currentDateTime.setHours(hoursIn24Format, minutes, 0, 0);

  // Get the time to compare (compareTime in 12-hour format with AM/PM)
  const compareDateTime = new Date();
  const compareTimeParts = compareTime.split(' ');
  const [compareHours, compareMinutes] = compareTimeParts[0].split(':');
  const compareAmpm = compareTimeParts[1];

  // Adjust the hours based on AM/PM
  let compareHoursIn24Format = parseInt(compareHours);
  if (compareAmpm === 'PM' && compareHoursIn24Format !== 12) {
    compareHoursIn24Format += 12;
  } else if (compareAmpm === 'AM' && compareHoursIn24Format === 12) {
    compareHoursIn24Format = 0;
  }

  // Set the compare time with adjusted hours and minutes
  compareDateTime.setHours(compareHoursIn24Format, compareMinutes, 0, 0);

  // Check if the compare time is in the future compared to current time
  if (compareDateTime > currentDateTime) {
    return true; // Future time
  }

  return false; // Past or same time
}



export const ConvertTime = (date, slot, u_zone, c_zone) => {
  let Offset = ZoneList.find((i) => i.value === c_zone).label.slice(4, 10);
  let bookingDate = date.split("-");
  var bookingTime = new Date(
    bookingDate[0] +
      " " +
      bookingDate[1] +
      " " +
      bookingDate[2] +
      "," +
      slot +
      "," +
      "GMT" +
      Offset
  ).toISOString();
  let newTime = moment(bookingTime).tz(u_zone).format("hh:mm A");
  return newTime;
};

export const setTimeLable = (h, m) => {
  var minutes = +h * 60 + +m;
  if (minutes < 60) {
    return true;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/checkSlots.js